export const expireToken = () => {
    setTimeout(() => {
        window.history.replaceState(null, '', '/');
        window.location.reload()
    }, 1000);
};